import React, { useEffect, useState, Fragment } from "react";
import { styled } from '@mui/material/styles';
import { getCallTypes } from "../../const/CardDati";
import { Autocomplete, TextField, Checkbox, Grid, Button, Card, CardContent, IconButton, CardActions, Collapse, Typography } from "@mui/material";
import { FormControl, FormLabel, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './AdvancedFilterPanel.module.css';
import axios from "axios";


const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  }));

const url = process.env.REACT_APP_URL;
const actionCallType = getCallTypes.action; 

function AdvancedFilterPanel({ isFetching, handleFilterData }) {
  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [radioRecoveryEnabled, setRadioRecoveryEnabled] = useState("null");
  const [radioDeviceEnabled, setRadioDeviceEnabled] = useState("null");
  const [inputCallSelect, setInputCallSelect] = useState('');
  const [selectedCallTypes, setSelectedCallTypes] = useState([]);
  const [isCallSelectOpen, setIsCallSelectOpen] = useState(false);
  const [selectCallOptions, setSelectCallOptions] = useState([]);
  const loadingCallState = isCallSelectOpen && selectCallOptions.length === 0;
  

  const handleRecoveryChange = (event) => {
    setRadioRecoveryEnabled(event.target.value);
  };

  const handleEnabledChange = (event) => {
    setRadioDeviceEnabled(event.target.value);
  };

  const handleInputChangeCallSelect = (event, value) => {
    setInputCallSelect(value);
  };

  const handleChangeCallSelect = (event, value) => {
    setSelectedCallTypes(value);
  };

  const loadCallSelectOptions = () => {
    (async (a) => {
      const response = await axios( url + actionCallType);
      setSelectCallOptions(response.data.result);
    })();
  };

  useEffect(() => {
    let active = true;
    
    if (!loadingCallState) {
      return undefined;
    }
    
    (async () => {   
      if (active) {
         loadCallSelectOptions();
      }
    })();

    return () => {
      active = false;
    };

  }, [loadingCallState]);


  return (
    <>
        <Grid container item>
          <Grid item component={Card} xs={12} sm={12} sx={{boxShadow: 0}}>
            <CardActions sx={{justifyContent: 'flex-end'}} disableSpacing>
                <Typography variant="button">{expanded ? 'Riduci' : 'Espandi'} Filtri Avanzati</Typography>
                <ExpandMore
                    expand={expanded}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                    >
                    <ExpandMoreIcon />
                </ExpandMore>
            </CardActions>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <CardContent>
                  <Grid container columnSpacing={3} rowSpacing={3}>
                      <Grid item xs={12} sm={3}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend">Recupero Pregresso</FormLabel>
                            <RadioGroup row aria-label="recoveryEnabled" name="row-radio-group-recovery" onChange={handleRecoveryChange} defaultValue="null">
                                <FormControlLabel value="null" control={<Radio />} label="Tutti" />
                                <FormControlLabel value="true" control={<Radio />} label="Solo Abilitati" />
                                <FormControlLabel value="false" control={<Radio />} label="Solo Non Abilitati" />
                            </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <FormControl component="fieldset">
                        <FormLabel component="legend">Abilitato</FormLabel>
                            <RadioGroup row aria-label="devicesEnabled" name="row-radio-group-enabled" onChange={handleEnabledChange} defaultValue="null">
                                <FormControlLabel value="null" control={<Radio />} label="Tutti" />
                                <FormControlLabel value="true" control={<Radio />} label="Solo Abilitati" />
                                <FormControlLabel value="false" control={<Radio />} label="Solo Non Abilitati" />
                            </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <Autocomplete
                              multiple
                              id="calltypes"
                              size="small"
                              open={isCallSelectOpen}
                              onOpen={() => {
                                setIsCallSelectOpen(true);
                              }}
                              onClose={() => {
                                setIsCallSelectOpen(false);
                              }}
                              loading={loadingCallState}
                              options={selectCallOptions}
                              value={selectedCallTypes}
                              disableCloseOnSelect
                              limitTags={1}
                              getOptionLabel={(option) => option.descrizione}
                              onChange={handleChangeCallSelect}
                              onInputChange={handleInputChangeCallSelect}
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                    checkedIcon={<CheckBoxIcon fontSize="small" />}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  {option.descrizione}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField {...params} label="Tipologia Chiamata" variant="standard" InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <Fragment>
                                        {loadingCallState ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                      </Fragment>
                                    ),
                                  }}
                                />
                              )}
                            />
                          </FormControl> 
                      </Grid>
                      <Grid container item>
                        <Grid item xs={12} className={styles.buttonGrid}>
                          <Button variant="contained" disabled={isFetching} className={styles.buttonStyle} onClick={() => {
                            handleFilterData(radioRecoveryEnabled, radioDeviceEnabled, selectedCallTypes);
                            }}>Applica</Button>
                        </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Collapse>
          </Grid>
        </Grid>
    </>
  );
}

export default AdvancedFilterPanel;
